<template>
    <div>
        <LabelContent title="基本信息" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
            </div>
        </LabelContent>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="150px" class="unitWidth" size="small">
                <el-form-item label="设备编号">
                    <el-input v-model.trim="searchParams.devCode" placeholder="请输入" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="计划工时">
                    <el-input v-model.trim="searchParams.pmoRatedHour" placeholder="请输入" :disabled="devCodeShow"></el-input>
                </el-form-item>
                <el-form-item label="计划执行月份">
                    <el-date-picker v-model="searchParams.pmoPlanTime" type="month" placeholder="选择日期时间" :disabled="devCodeShow">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="执行开始时间">
                    <el-date-picker v-model="searchParams.pmoPlanStartTime" type="datetime" placeholder="选择日期时间" :disabled="pmoPlanTimeShow">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="执行结束时间">
                    <el-date-picker v-model="searchParams.pmoPlanEndTime" type="datetime" placeholder="选择日期时间" :disabled="pmoPlanTimeShow">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="editPlanMantainOrder" :disabled="timeDisabled">确定</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <el-tabs v-model="activeName">
            <!--计划保养项-->
            <el-tab-pane label="计划保养项" name="first">
                <LabelContent title="计划保养项" ref="LabelContent">
                    <div slot="btns">
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                        <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="planMaintainOrderItemList" class="center">
                        <el-table-column prop="pmiPart" sortable label="保养部位" show-overflow-tooltip />
                        <el-table-column prop="pmiItem" sortable label="保养内容" show-overflow-tooltip />
                        <el-table-column prop="dtlResult" sortable label="保养结果" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="searchParams.pmoStatus != 'create'">{{scope.row.dtlResult == true?'合格':'不合格'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="dtlNotes" sortable label="备注" show-overflow-tooltip />
                        <el-table-column prop="dtlPic" sortable label="图片" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div style="width: 10vw;" v-if="scope.row.dtlPic.length != 0" v-for="pic in scope.row.dtlPic">
                                    <ul style="float: left;padding: 10px;">
                                        <li>
                                            <el-popover placement="left" trigger="click" width="500">
                                                <img :src="pic" width="100%"/>
                                                <img slot="reference" :src="pic" :alt="pic" style="height: 50px;width: 50px; padding: 5px"/>
                                            </el-popover>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" sortable label="创建时间" show-overflow-tooltip />
                        <!--<el-table-column prop="logType" sortable label="日志类型" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.logType == 'status_change'">状态流转</span>
                                <span v-if="scope.row.logType == 'order_accept'">验收</span>
                                <span v-if="scope.row.logType == 'wait'">待定</span>
                            </template>
                        </el-table-column>-->
                    </el-table>
                </div>
            </el-tab-pane>
            <!--计划工单日志-->
            <el-tab-pane label="计划工单日志" name="second">
                <LabelContent title="计划工单日志" ref="LabelContent">
                    <div slot="btns">
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                        <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="planMaintainLogList" class="center">
                        <el-table-column prop="pmoNo" sortable label="计划保养工单" show-overflow-tooltip />
                        <el-table-column prop="pmlTitle" sortable label="记录标题" show-overflow-tooltip />
                        <el-table-column prop="pmlContent" sortable label="记录内容" show-overflow-tooltip />
                        <el-table-column prop="createUserName" sortable label="创建人" show-overflow-tooltip />
                        <el-table-column prop="createTime" sortable label="创建时间" show-overflow-tooltip />
                        <!--<el-table-column prop="logType" sortable label="日志类型" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.logType == 'status_change'">状态流转</span>
                                <span v-if="scope.row.logType == 'order_accept'">验收</span>
                                <span v-if="scope.row.logType == 'wait'">待定</span>
                            </template>
                        </el-table-column>-->
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: 'editPlanMantainOrder',
        data(){
            return{
                searchParams: {},
                timeDisabled:false,
                planMaintainLogList:[],
                planMaintainOrderItemList:[],
                devCodeShow:false,
                pmoPlanTimeShow:false,
                activeName:'first',
                access:[]
            }
        },
        mounted() {
            this.init()
        },
        methods:{
            init(){
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                /*for (let i = 0; i < this.access.length; i++) {
                    if(this.access[i] == 'D0001'){
                        this.devCodeShow = false
                        break
                    }else{
                        this.devCodeShow = true
                    }
                }
                for (let j = 0; j < this.access.length; j++) {
                    if(this.access[j] == 'D0002'){
                        this.pmoPlanTimeShow = false
                        break
                    }else{
                        this.pmoPlanTimeShow = true
                    }
                }*/
                /*if(this.$route.params.planMantainOrder != undefined && this.$route.params.planMantainOrder != ''){
                    this.searchParams = this.$route.params.planMantainOrder
                    sessionStorage.setItem('PlanMantainOrder', JSON.stringify(this.searchParams))
                    if(this.searchParams.hasOwnProperty('pmoPlanStartTime') && this.searchParams.hasOwnProperty('pmoPlanEndTime')){
                        this.timeDisabled = true
                        this.devCodeShow = true
                        this.pmoPlanTimeShow = true
                    }else if(this.searchParams.pmoPlanStartTime == undefined || this.searchParams.pmoPlanStartTime == '' ||
                        this.searchParams.pmoPlanEndTime == undefined || this.searchParams.pmoPlanEndTime == ''){
                        this.timeDisabled = false
                    }
                }else{
                    this.searchParams = JSON.parse(sessionStorage.getItem('PlanMantainOrder'))
                    if(this.searchParams.hasOwnProperty('pmoPlanStartTime') && this.searchParams.hasOwnProperty('pmoPlanEndTime')){
                        this.timeDisabled = true
                        this.devCodeShow = true
                        this.pmoPlanTimeShow = true
                    }else if(this.searchParams.pmoPlanStartTime == undefined || this.searchParams.pmoPlanStartTime == '' ||
                        this.searchParams.pmoPlanEndTime == undefined || this.searchParams.pmoPlanEndTime == ''){
                        this.timeDisabled = false
                    }
                }*/
                if(this.$route.params.planMantainOrder != undefined && this.$route.params.planMantainOrder != ''){
                    this.searchParams = this.$route.params.planMantainOrder
                    if(this.searchParams.pmoStatus == 'create'){
                        this.timeDisabled = false
                        this.devCodeShow = false
                        this.pmoPlanTimeShow = false
                    }else{
                        this.timeDisabled = true
                        this.devCodeShow = true
                        this.pmoPlanTimeShow = true
                    }
                    sessionStorage.setItem('PlanMantainOrder', JSON.stringify(this.searchParams))
                }else{
                    this.searchParams = JSON.parse(sessionStorage.getItem('PlanMantainOrder'))
                    if(this.searchParams.pmoStatus == 'create'){
                        this.timeDisabled = false
                        this.devCodeShow = false
                        this.pmoPlanTimeShow = false
                    }else{
                        this.timeDisabled = true
                        this.devCodeShow = true
                        this.pmoPlanTimeShow = true
                    }
                }
                if(this.searchParams){
                    this.getPlanMaintainLogPmoNo()
                    this.getPlanMainOrderItemPmoNo()
                    this.getPlanMaintainOrderPmoNo()
                }
            },
            getPlanMaintainOrderPmoNo() {
                let params = {
                    pmoNo: this.searchParams.pmoNo
                }
                let options = {
                    method: 'get',
                    url: this.$api.getPlanMaintainOrderPmoNo,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            this.searchParams = JSON.parse(JSON.stringify(response.data))
                        }
                    }
                })
            },
            editPlanMantainOrder(){
                var self = this
                /*if(self.searchParams.pmoPlanTime == undefined || self.searchParams.pmoPlanTime == ''){
                    self.$message.info("请输入计划执行时间")
                    return
                }
                if(self.searchParams.pmoRatedHour == undefined || self.searchParams.pmoRatedHour == ''){
                    self.$message.info("请输入计划工时")
                    return
                }*/
                let queryParams = {
                    devCode:self.searchParams.devCode,
                    pmoId:self.searchParams.pmoId,
                    pmoPlanTime:moment(self.searchParams.pmoPlanTime).format("YYYY-MM"),
                    pmoRatedHour:self.searchParams.pmoRatedHour
                }
                if(self.searchParams.pmoPlanStartTime != undefined && self.searchParams.pmoPlanStartTime != ''){
                    queryParams['pmoPlanStartTime'] = self.dateFormat(self.searchParams.pmoPlanStartTime)
                }
                if(self.searchParams.pmoPlanEndTime != undefined && self.searchParams.pmoPlanEndTime != ''){
                    queryParams['pmoPlanEndTime'] = self.dateFormat(self.searchParams.pmoPlanEndTime)
                }
                let options = {
                    method:'POST',
                    url:this.$api.editPlanMaintainOrder,
                    data:queryParams
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        self.$message.success("编辑成功")
                        self.getPlanMaintainOrderPmoNo()
                    }else{
                        self.$message.error("编辑失败")
                    }
                })
            },
            getPlanMaintainLogPmoNo(){
                if(this.searchParams.pmoNo == undefined || this.searchParams.pmoNo == ''){
                    return
                }
                let queryParams = {
                    pmoNo:this.searchParams.pmoNo
                }
                let options = {
                    method:'GET',
                    url:this.$api.getPlanMaintainLogPmoNo,
                    params:queryParams
                }
                var self = this
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        self.planMaintainLogList = response.data
                    }
                })
            },
            getPlanMainOrderItemPmoNo(){
                if(this.searchParams.pmoNo == undefined || this.searchParams.pmoNo == ''){
                    return
                }
                let queryParams = {
                    pmoNo:this.searchParams.pmoNo
                }
                let options = {
                    method:'GET',
                    url:this.$api.getPlanMainOrderItemPmoNo,
                    params:queryParams
                }
                var self = this
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        self.planMaintainOrderItemList = []
                        var aa = response.data
                        if(aa != undefined && aa != ''){
                            for (let i = 0; i < aa.length; i++) {
                                var arr = {
                                    pmiPart:'',
                                    pmiItem:'',
                                    dtlResult:'',
                                    dtlNotes:'',
                                    createTime:'',
                                    dtlPic:[]
                                }
                                arr.pmiPart = aa[i].pmiPart
                                arr.pmiItem = aa[i].pmiItem
                                arr.dtlResult = aa[i].dtlResult
                                arr.dtlNotes = aa[i].dtlNotes
                                arr.createTime = aa[i].createTime
                                if(aa[i].dtlPic != undefined && aa[i].dtlPic != ''){
                                    var pic = aa[i].dtlPic.split(',')
                                    for (let j = 0; j < pic.length; j++) {
                                        arr.dtlPic.push(pic[j])
                                    }
                                }
                                self.planMaintainOrderItemList.push(arr)
                            }
                        }
                    }
                })
            },
            dateFormat(date){
                return moment(date).format("YYYY-MM-DD HH:mm:ss")
            }
        }
    }
</script>

<style scoped>

</style>
